/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

const FooterLandAck = () => {
    //TODO: SC-2340 - Add link to internal Haisla Nation page once ready
    return (
        <div className="footer-land-ack">
            <p>
                We respectfully acknowledge that we live and work within the unceded territory of the x̄á’isla (Haisla) Nation.
            </p>
        </div>
    );
};

export { FooterLandAck };
